import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import WwwLayout from "./Layout";
import HomePage from "./pages/HomePage";
import { SignIn } from "@coremind/identity-ui";
import { useNavigate } from "react-router-dom";
function SignInPage() {
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(true);
    const handleClose = () => { setOpen(false); navigate("/"); };
    return (_jsx(SignIn, { open: open, onClose: handleClose, closeOnSuccess: true, showSignupPrompt: true }));
}
export const wwwAdapter = {
    siteId: "coremind-site-www",
    version: "0.1.0",
    theme: {},
    layout: WwwLayout,
    metadata: {
        name: "Offsetmind",
        description: "The Offsetmind platform landing page — discover and join platform sites.",
    },
    navigation: { primary: [] },
    routes: [
        { path: "/", component: HomePage },
        { path: "/signin", component: SignInPage },
    ],
};
